var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGraduationHatGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 9.66667V7.66295C11.3334 7.5433 11.3334 7.48348 11.3152 7.43066C11.299 7.38395 11.2728 7.34141 11.2382 7.30611C11.1991 7.26619 11.1456 7.23944 11.0386 7.18593L8.00004 5.66667M2.66671 6.33334V10.8711C2.66671 11.119 2.66671 11.243 2.70539 11.3515C2.73958 11.4475 2.79531 11.5343 2.86829 11.6054C2.95085 11.6858 3.06356 11.7374 3.28894 11.8408L7.55561 13.7963C7.7191 13.8712 7.80084 13.9087 7.886 13.9235C7.96146 13.9366 8.03862 13.9366 8.11408 13.9235C8.19924 13.9087 8.28098 13.8712 8.44447 13.7963L12.7111 11.8408C12.9365 11.7374 13.0492 11.6858 13.1318 11.6054C13.2048 11.5343 13.2605 11.4475 13.2947 11.3515C13.3334 11.243 13.3334 11.119 13.3334 10.8711V6.33334M1.33337 5.66667L7.76153 2.45259C7.84898 2.40887 7.89271 2.387 7.93857 2.3784C7.9792 2.37078 8.02088 2.37078 8.06151 2.3784C8.10737 2.387 8.1511 2.40887 8.23855 2.45259L14.6667 5.66667L8.23855 8.88075C8.1511 8.92447 8.10737 8.94634 8.06151 8.95494C8.02088 8.96256 7.9792 8.96256 7.93857 8.95494C7.89271 8.94634 7.84898 8.92447 7.76153 8.88075L1.33337 5.66667Z",
    stroke: "#98A2B3",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationHatGray);
export default __webpack_public_path__ + "static/media/graduation-hat-gray.36c05b5bc009bfb3db99c0eaa625b6a2.svg";
export { ForwardRef as ReactComponent };